define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi",
	"csi/heading/_base",
	"csi/heading/EnumController",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,domClass,csi,heading,EnumController,MessageDialog,xml) {

	return declare(EnumController, {
		process: function() {
			if (xml.enumGetText(this.oldValue)) {
				this.confirmAction({});
			} else {
				this.inherited(arguments);
			}
		},

		getConfirmButton: function() {
			return MessageDialog.BUTTON_RESET;
		},

		onConfirm: function(/*String*/key) {
			if (key == MessageDialog.BUTTON_RESET) {
				EnumController.prototype.process.call(this);
			} else {
				this.postProcess();
			}
		}
	});
});